import { render, staticRenderFns } from "./ModelCard.vue?vue&type=template&id=52da81cd&scoped=true"
import script from "./ModelCard.vue?vue&type=script&lang=js"
export * from "./ModelCard.vue?vue&type=script&lang=js"
import style0 from "./ModelCard.vue?vue&type=style&index=0&id=52da81cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da81cd",
  null
  
)

export default component.exports